import { IconTab } from "@/src/components/iconTab";
import { Evolution, Hospitalisation, Patient } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getUserId } from "@/src/utils/utils";
import { FaStethoscope } from "react-icons/fa";
import { getStandardConfidentiality } from "../../patients/confidentialitiesHook";
import openEvolutionStandardForm from "../openEvolutionItemStandardForm";

function EvolutionButton({
  patient,
  parent,
  onSave,
}: {
  patient: Patient;
  parent: Hospitalisation;
  onSave: (item: Evolution) => void;
}) {
  return (
    <IconTab
      id={"evolution"}
      activeTabId={null}
      isHorizontal={true}
      name={"Mot d'évolution"}
      icon={<FaStethoscope size={20} />}
      onChange={async () => {
        let item: Evolution = {
          type: "evolution",
          patient,
          creator: getUserId(),
          parent,
          functionalSigns: [],
          physicalSigns: [],
          readBy: [getUserId()],
          confidentiality: getStandardConfidentiality(patient),
        };
        await openEvolutionStandardForm({
          item,
          patient,
          onConfirm: async (newItem) => {
            newItem = await apiFetch("evolutions", "addOne", {
              evolution: newItem,
            });
            onSave(newItem);
          },
        });
      }}
    />
  );
}

export default EvolutionButton;
